import axios from "axios";
import qs from "qs";
import JSEncrypt from "jsencrypt";
let Base64 = require("js-base64").Base64;
import global from "@/core/global/global";
import SparkMD5 from "spark-md5";
import { log } from "console";

axios.defaults.timeout = 500000; //响应时间
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = "";


// v3.0.5 cn-sign参数
var encryptStr = new JSEncrypt();
// 设置 加密公钥（正常从getPK接口获取，此处固定）
encryptStr.setPublicKey("MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAj1YbgGwvllFenGuQOkG0ToCn7HvtCBSSJ3N2Xs72hOxVU/SZgnh6zCa/9jtse6jZjNIyaXd3A3LN4iTbb/andtKZ2VrhY9GgSTlpGwgZxTqhAXTS1+DN/fIw43gsllbspFoeKkbzKyh7rGN5hXdHnDj8PytAWn3cK+emXgSeEc4Mj0LTV8CZM8AWhJ/deoer6pi5oggHUPuM2wY8RqhSfYuvZkza2I0Eghi8AUL97HbbKjm6Y6sz7qkh0nEKiU19O/asfI/qvxYejUC5KEugieXzES8Auoa2h8UOiN/sc2uah2o32QG2mT76CsL/dTHwhzOFz3JvjBug8VSuNF9hYwIDAQAB"); 

// 添加请求拦截器
axios.interceptors.request.use(
  async (config) => {
    // 中文知识网新增参数 获取公网Ip地址接口(借助三方接口) 环境上不需要加前缀
    let cnsign =
            Math.floor(10000000 + Math.random() * 90000000) +
            "zwjt8081!@#DF*F&^SKD" +
            new Date().getTime();
       
    axios.defaults.headers["cn-sign"] = encryptStr.encrypt(cnsign);
    axios.defaults.headers["timer"] = new Date().getTime();
    if (sessionStorage.getItem("userInfo")) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //取出sesion
      const token = userInfo.token;
      if (token) {
        config.headers.common["token"] = token
        let ip = sessionStorage.getItem('webIp')
        let timestamp = new Date().getTime()
        let nonce = ip + '-' + timestamp
  
        let sign = token + nonce
        let spark = new SparkMD5()
        spark.append(sign);
        let signMd5 = spark.end();
        config.headers['zw-nonce'] = nonce
        config.headers['zw-sign'] = signMd5
        
      }
    }
   
   
   
    return config;
  },
  (error) => {
    return Promise.reject(error);
   }
);

const HTTP = {};

HTTP.setToken = function(token) {
  axios.defaults.headers.post["token"] = token;
  axios.defaults.headers.get["token"] = token;
};

HTTP.json = function(url, params, parseResult = true) {
  if (params) {
    let param = JSON.stringify(params);
    // var pubKey = window.sessionStorage.getItem("trip");
    // // var encryptStr = new JSEncrypt();
    // encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    var datas = encryptStr.encrypt(param); // 进行加密
  } else {
    var datas = params;
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, datas, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(
        (response) => {
          let result = response.data;
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content);
            } else {
              reject(result);
            }
          } else {
            resolve(result);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
};
// HTTP.delete = function (url, params, parseResult = true) {
//     if (params) {
//         let param = JSON.stringify(params)
//         var pubKey = window.sessionStorage.getItem('trip')
//         var encryptStr = new JSEncrypt();
//         encryptStr.setPublicKey(pubKey); // 设置 加密公钥
//         var datas = encryptStr.encrypt(param);  // 进行加密
//     }
//     else {
//         var datas = params
//     }
//     return new Promise((resolve, reject) => {
//         axios.delete(url, datas, {
//             headers: {
//                 "content-Type": "application/json",
//             }
//         })
//             .then(
//                 response => {
//                     let result = response.data
//                     if (parseResult) {
//                         if (response.status === 200) {
//                             resolve(result.content)
//                         } else {
//                             reject(result);
//                         }
//                     } else {
//                         resolve(result)
//                     }
//                 },
//                 err => {
//                     reject(err)
//                 }
//             )
//             .catch(error => {
//                 reject(error)
//             })
//     })
// }
HTTP.DELETE = function(url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url + "?" + qs.stringify(params), {
        headers: {},
      })
      .then(
        (response) => {
          let result = response.data;
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content);
            } else {
              reject(result);
            }
          } else {
            resolve(result);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
};
HTTP.get = function(url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          "content-Type": "application/json",
        },
        params,
      })
      .then(
        (response) => {
          let result = response.data;
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content);
            } else {
              reject(result.content);
            }
          } else {
            resolve(result);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
};
HTTP.post = function(url, params, parseResult = true) {
  if (params) {
    let base = "";

    for (let key in params) {
      base += key + "=" + params[key] + "&";
    }
    base = base.substr(0, base.length - 1);
    // var pubKey = window.sessionStorage.getItem("trip");
    // var encryptStr = new JSEncrypt();
    // encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    var datas = encryptStr.encrypt(base); // 进行加密
  } else {
    var datas = params;
  }

  //        params = Base64.encode(datas);
  return new Promise((resolve, reject) => {
    axios
      .post(url, datas, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then(
        (response) => {
          let result = response.data;
          if (parseResult) {
            if (response.status === 200) {
              resolve(result.content);
            } else {
              reject(result);
            }
          } else {
            resolve(result);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
};
HTTP.postFormData = function(url, params, parseResult = true) {
  return new Promise((resolve, reject) => {
     // v3.0.5 cn-sign参数
     var encryptStr = new JSEncrypt();
     // 设置 加密公钥（正常从getPK接口获取，此处固定）
     encryptStr.setPublicKey("MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAj1YbgGwvllFenGuQOkG0ToCn7HvtCBSSJ3N2Xs72hOxVU/SZgnh6zCa/9jtse6jZjNIyaXd3A3LN4iTbb/andtKZ2VrhY9GgSTlpGwgZxTqhAXTS1+DN/fIw43gsllbspFoeKkbzKyh7rGN5hXdHnDj8PytAWn3cK+emXgSeEc4Mj0LTV8CZM8AWhJ/deoer6pi5oggHUPuM2wY8RqhSfYuvZkza2I0Eghi8AUL97HbbKjm6Y6sz7qkh0nEKiU19O/asfI/qvxYejUC5KEugieXzES8Auoa2h8UOiN/sc2uah2o32QG2mT76CsL/dTHwhzOFz3JvjBug8VSuNF9hYwIDAQAB");
     let cnsign =
       Math.floor(10000000 + Math.random() * 90000000) +
       "zwjt8081!@#DF*F&^SKD" +
      new Date().getTime();
    axios.defaults.headers["cn-sign"] = encryptStr.encrypt(cnsign);
    axios.defaults.headers["timer"] = new Date().getTime();
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json",
          rsa: "no",
          token: sessionStorage.getItem("token"),
          // "cn-sign":encryptStr.encrypt(cnsign)
        },
      })
      .then(
        (response) => {
          let result = response.data;

          if (parseResult) {
            if (result.code === 0) {
              resolve(result.message);
            } else {
              reject(result);
            }
          } else {
            resolve(result);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
};

export default HTTP;



// WEBPACK FOOTER //
// ./src/core/api/config/api.js